import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from '../i18n/useTranslation';
import i18n from '../i18n/i18n';
import { GlobeIcon, ChevronDownIcon, CheckIcon } from 'lucide-react';
const LanguageSwitcher = () => {
  const {
    i18n
  } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Language options with display names
  const languages = [{
    code: 'en',
    name: 'English'
  }, {
    code: 'ja',
    name: '日本語'
  }, {
    code: 'es',
    name: 'Español'
  }, {
    code: 'de',
    name: 'Deutsch'
  }, {
    code: 'ar',
    name: 'العربية'
  }, {
    code: 'he',
    name: 'עברית'
  }, {
    code: 'zh',
    name: '中文'
  }];
  // Keep local state in sync with i18n language
  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setCurrentLanguage(lng);
    setIsOpen(false);
    // Store the selected language in localStorage to persist across sessions
    localStorage.setItem('i18nextLng', lng);
    console.log(`Language changed to: ${lng}`);
    // For RTL languages (Arabic and Hebrew), set the dir attribute
    if (lng === 'ar' || lng === 'he') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  };
  // Get current language display name
  const getCurrentLanguageName = () => {
    const lang = languages.find(l => l.code === currentLanguage);
    return lang ? lang.name : 'English';
  };
  return <div className="fixed bottom-4 left-4 z-50" ref={dropdownRef} data-id="element-1950">
      <div className="bg-white rounded-lg shadow-md border border-gray-200" data-id="element-1951">
        <button className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-indigo-600 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-1952">
          <GlobeIcon className="h-4 w-4 mr-2" data-id="element-1953" />
          <span data-id="element-1954">{getCurrentLanguageName()}</span>
          <ChevronDownIcon className={`h-4 w-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-1955" />
        </button>
        {isOpen && <div className="absolute bottom-full mb-2 bg-white rounded-lg shadow-lg border border-gray-200 py-1 w-40 max-h-60 overflow-y-auto" data-id="element-1956">
            {languages.map(lang => <button key={lang.code} className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center justify-between ${currentLanguage === lang.code ? 'text-indigo-600 font-medium bg-indigo-50' : 'text-gray-700'}`} onClick={() => changeLanguage(lang.code)} data-id="element-1957">
                <span data-id="element-1958">{lang.name}</span>
                {currentLanguage === lang.code && <CheckIcon className="h-4 w-4" data-id="element-1959" />}
              </button>)}
          </div>}
      </div>
    </div>;
};
export default LanguageSwitcher;